
import React, { useState, useEffect } from 'react';
import { Modal, Input, Row, Col, Button, Space, Avatar, Select } from 'antd';  
import './AddEdit.less';
import { Demand, DemandAddEditParam } from '../model'; 
import { ctrl } from '../controller';
import { User } from '@/common/model';
import UserIcon from '@/components/UserIcon/UserIcon'; 
import { globalStore } from '@/common';
import UserSelect from '@/components/UserSelect/UserSelect';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import StatusSelect from '@/components/StatusSelect/StatusSelect';

const { TextArea } = Input;
const { Option } = Select;

interface AddEditProps {
  visible: boolean;
  onClose: () => void;
  demand?: Demand;
  currentUser?: User; 
}

const AddEdit: React.FC<AddEditProps> = ({ visible, onClose, demand, currentUser }) => {
  const [description, setDescription] = useState(demand ? demand.content : '需求描述：\n解决问题：');
  const [executorId, setExecutorId] = useState(demand ? demand.executorId : undefined);
  const [submitterId, setSubmitterId] = useState(demand ? demand.submitterId : currentUser? currentUser.id: undefined); 
  const [status, setStatus] = useState(demand ? demand.status : 0);

  useEffect(() => {
    setExecutorId(demand ? demand.executorId : undefined);
    setSubmitterId(demand ? demand.submitterId : currentUser? currentUser.id: undefined);
    setDescription(demand ? demand.content : '需求描述：\n解决问题：')
    setStatus(demand ? demand.status : 0)
  }, [demand]);

  const isEdit = !!demand;

  if(!isEdit && !currentUser){
    //初始化状态下，无需渲染
    return '';
  }

  const handleConfirmAndAddOrUpdateDemand = () => {
    const tempDemand: DemandAddEditParam = { 
      id: isEdit ? demand!.id : null,  
      content: description,
      submitterId: submitterId, 
      executorId: executorId!,
      status
    };
    if (isEdit) {
      ctrl.updateDemand(tempDemand);
    } else {
      ctrl.addDemand(tempDemand);
    }
    onClose();
  };

  return (
    <Modal
      title={isEdit ? '编辑需求' : '添加需求'}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      className='demand-edit-model'
    >
      <Space direction="vertical" className="add-edit-space" size={20}>
        <Input.TextArea
          value={description}
          defaultValue={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder={`需求描述：\n解决问题：`}
          rows={4}
          className='description-input-text-area'
          maxLength={500}
        />
         {isEdit && (
          <Row>
            <Col span={4} className='attr-title'>提报时间：</Col>
            <Col span={20} className='attr-text-value'>
              {moment(demand.submitTime).format('YYYY年MM月DD日 HH:mm')}
            </Col>
          </Row>
        )}
        <Row>
          <Col span={4} className='attr-title'>提出人员：</Col>
          <Col span={20} style={{paddingLeft:8}}>
               <UserIcon showName effect='post' id={submitterId+""} />
          </Col>
        </Row>
        <Row>
          <Col span={4} className='attr-title'>负责人员：</Col>
          <Col span={20} >
              <UserSelect
                userMap={globalStore.userMap}
                mode="single"
                value={executorId}
                onMultipleSelect={() => {}}
                onSingleSelect={(item) => setExecutorId(item?.id)}
              />
          </Col>
        </Row>
        <Row>
          <Col span={4} className='attr-title'>需求状态：</Col>
          <Col span={20}>

            <StatusSelect
                    placeholder="项目状态"
                    value={status}
                    valueList={[0,1,2]}
                    statusList={['待立项','已立项','已废弃']}
                    colorList={['#248dea','#0ea913','#979797']}
                    onChange={(value) => setStatus(value)}
                    width={120}
                  > 
            </StatusSelect> 


          </Col>
        </Row>
        
       
        <Row justify="end" className='op-line'>
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" onClick={handleConfirmAndAddOrUpdateDemand} className="confirm-button">
            确认
          </Button>
        </Row>
      </Space>
    </Modal>
  );
};

export default AddEdit;

/*

  帮我写一个需求管理模块的【添加/编辑】需求的弹框，要求如下：
  标题会动态变化，如果是新增，则为：添加需求，如果是编辑已有的需求，则为：编辑需求
  添加需求的弹框页面内容为：
  第一行为一个最大4行的文本输入区，其中placeholder为2行：
  ```
  需求描述：
  解决问题：
  ```
  第二行 分为两列，第一列为文案“提出人员”，第二列为 当前用户的头像和姓名
  第三行 分为两列，第一列为文案“负责人员”，第二列为 一个下拉用户单选框，用<SingleUserSlect />组件代替（不用实现，我已经实现了）
  第四行 分为两列，第一列为文案“需求状态”，第二列为 一个下拉单选框，包含三个选项：待立项、已立项、已废弃。单选框的边框颜色随着选项不同而不同，分别变化为：蓝色、绿色、灰色。默认选择为待立项。
  第五行 仅在编辑需求的时候出现，分为两列，第一列为文案“提报时间”，第二列为 需求的创建日期，格式为 XX月XX日 XX时XX分
  第六行 为两个靠右的按钮，分别为取消和确认，点击确认执行对应的操作（新增/更新需求）。
  整个组件接受一个Demand的对象：
  ```
    export interface Demand{
        id:number
        code:string
        content:string
        submitterId:number
        submitterName:string
        executorId:number
        executorName:string
        submitTime:Date
        status:number
        comments:Comment[]
        logs:OperationLog[] 
    }
  ```
  要求：
  1、把逻辑代码和样式代码分别写在AddEdit.tsx和AddEdit.less中。
  2、布局使用Ant-D的Space、Row、Col组件，尽量不使用div
  3、弹框使用Ant-D的Modal组件，宽度为700px
  4、组件属性要包含一个可选的Demand对象，代表编辑已有的需求。如果不传，代表是新增
  5、新增的函数和更新的函数分别用 addDemand(demand)和 updateDemand(demand)

*/